import $ from 'jquery';

// console.log("inside menu tabs ...", Tabs);
export default() => {
    (function (Tabs, $) {
        console.log("initialize Tabs", Tabs);
        console.log("$", $);
        var tabsInit = function tabsInit() {
            $('.jsTabs li').click(function () {

                var tab_id = $(this).attr('data-tab');

                $('.jsTabs li').removeClass('current');
                $('.jsTabsContent').removeClass('current');

                $(this).addClass('current');
                $("#" + tab_id).addClass('current');
            });
        };

        Tabs.init = function () {
            tabsInit();
        };
    })(window.Tabs = window.Tabs || {}, $, undefined);
};